export default __webpack_public_path__ + "e1bb672859e426d932eb1d754a68a8b0.png";